import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context';
import { ROUTES, ROLES } from '@/constants';
import PageLoader from '@/components/PageLoader';

function PublicRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <PageLoader message="Checking authentication..." />;
  }

  if (isAuthenticated) {
    const home = user?.role === ROLES.SCORER ? ROUTES.MATCHES : ROUTES.DASHBOARD;
    return <Navigate to={home} replace />;
  }

  return <Outlet />;
}

export default PublicRoute;
